import './instrument';
import * as Sentry from '@sentry/react';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initAnalytics } from './lib/analytics';

// Fire and forget: initAnalytics resolves isSupported() asynchronously, and any
// event logged before it lands is queued rather than dropped. Never awaited, so
// a blocked measurement endpoint cannot delay first paint.
void initAnalytics();

createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
